window.KAIA_SAMPLE_CATALOG = {
  "generatedAt": "2026-10-25T15:58:04.263Z",
  "categories": {
    "Shower": [
      {
        "id": "gid://shopify/Product/10054709018908",
        "handle": "rose-jam-shower-gel",
        "variantId": "gid://shopify/ProductVariant/51328879984924",
        "name": "Rose Jam Shower gel",
        "productType": "Shower Gel",
        "strapline": "Delicate rose & bright lemon",
        "scent": "Gourmand",
        "benefit": "Soothing",
        "badge": "",
        "badgeColor": "#000000",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/rose_jam_shower_gel_02.jpg?v=1741165995",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC09587.jpg?v=1741166017",
        "imageAlt": "A red circular swatch of a lush shower gel that smells like roses. ",
        "productUrl": "https://lush.co.za/products/rose-jam-shower-gel",
        "inStock": true,
        "category": "Shower"
      },
      {
        "id": "gid://shopify/Product/10054709149980",
        "handle": "sticky-dates-shower-scrub",
        "variantId": "gid://shopify/ProductVariant/51334430654748",
        "name": "Sticky Dates Sugar Scrub",
        "productType": "Body Scrub",
        "strapline": "Golden toffee-scented scrub",
        "scent": "Gourmand",
        "benefit": "Softening",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/sticky_dates_body_scrub_02.jpg?v=1710507998",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC09549.jpg?v=1741167963",
        "imageAlt": "A brown circular swatch of a lush sugar scrub that smells like warm pudding. ",
        "productUrl": "https://lush.co.za/products/sticky-dates-shower-scrub",
        "inStock": true,
        "category": "Shower"
      },
      {
        "id": "gid://shopify/Product/10054709182748",
        "handle": "honey-i-washed-the-kids-showergel",
        "variantId": "gid://shopify/ProductVariant/51334457491740",
        "name": "Honey I washed the Kids Showergel",
        "productType": "Shower Gel",
        "strapline": "Sweet caramel showers",
        "scent": "Gourmand",
        "benefit": "Soothing",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/honey_I_washed_the_kids_shower_gel_02.jpg?v=1690450462",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC09590.jpg?v=1741165929",
        "imageAlt": "A yellow circular swatch of a lush shower gel that smells like honey. ",
        "productUrl": "https://lush.co.za/products/honey-i-washed-the-kids-showergel",
        "inStock": false,
        "category": "Shower"
      },
      {
        "id": "gid://shopify/Product/10054709248284",
        "handle": "rub-rub-rub-scrub",
        "variantId": "gid://shopify/ProductVariant/51334504874268",
        "name": "Rub, Rub, Rub Scrub",
        "productType": "Body Scrub",
        "strapline": "A sweet, fresh, sea salt scrub",
        "scent": "Citrus",
        "benefit": "Softening",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/rub_rub_swatch.png?v=1725536206",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC09584.jpg?v=1741165511",
        "imageAlt": "A clear blue textured swatch of a lush salt scrub that smells like citrus. ",
        "productUrl": "https://lush.co.za/products/rub-rub-rub-scrub",
        "inStock": true,
        "category": "Shower"
      },
      {
        "id": "gid://shopify/Product/10156765511964",
        "handle": "sample-orange-scrub",
        "variantId": "gid://shopify/ProductVariant/51849545875740",
        "name": "Orange Scrub",
        "productType": "Body Scrub",
        "strapline": "Freshly squeezed citrus scrub",
        "scent": "Citrus",
        "benefit": "Softening",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/orange_scrub_01.png?v=1725536918",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC09781.jpg?v=1747235861",
        "imageAlt": "An orange textured swatch of a lush salt scrub that smells like fresh oranges. ",
        "productUrl": "https://lush.co.za/products/sample-orange-scrub",
        "inStock": true,
        "category": "Shower"
      },
      {
        "id": "gid://shopify/Product/10192992829724",
        "handle": "sample-grass-shower-gel",
        "variantId": "gid://shopify/ProductVariant/52609369702684",
        "name": "Grass Shower gel",
        "productType": "Shower Gel",
        "strapline": "Gorgeously green and uplifting",
        "scent": "Fresh",
        "benefit": "Cleansing",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/Screenshot2024-01-25111640.png?v=1706174227",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC00273.jpg?v=1753299356",
        "imageAlt": "A clear green circular swatch of a lush shower gel that smells like cut grass. ",
        "productUrl": "https://lush.co.za/products/sample-grass-shower-gel",
        "inStock": true,
        "category": "Shower"
      },
      {
        "id": "gid://shopify/Product/10192992895260",
        "handle": "sample-sleepy-shower-gel",
        "variantId": "gid://shopify/ProductVariant/52609380778268",
        "name": "Sleepy Shower gel",
        "productType": "Shower Gel",
        "strapline": "Skin softening, sleep-inducing",
        "scent": "Floral",
        "benefit": "Calming",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/sleepy_shower_gel_02.jpg?v=1690452215",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC00275.jpg?v=1753299272",
        "imageAlt": "A purple circular swatch of a lush shower gel that smells like lavender. ",
        "productUrl": "https://lush.co.za/products/sample-sleepy-shower-gel",
        "inStock": true,
        "category": "Shower"
      },
      {
        "id": "gid://shopify/Product/10192992928028",
        "handle": "sample-sticky-dates-shower-gel",
        "variantId": "gid://shopify/ProductVariant/52609391395100",
        "name": "Sticky Dates Shower gel",
        "productType": "Shower Gel",
        "strapline": "Rich date syrup and vanilla suds",
        "scent": "Gourmand",
        "benefit": "Hydrating",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/sticky_dates_shower_gel_02.jpg?v=1690452491",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC00268.jpg?v=1753298949",
        "imageAlt": "A brown circular swatch of a lush shower gel that smells like warm pudding. ",
        "productUrl": "https://lush.co.za/products/sample-sticky-dates-shower-gel",
        "inStock": true,
        "category": "Shower"
      },
      {
        "id": "gid://shopify/Product/10192994533660",
        "handle": "sample-happy-hippy-shower-gel",
        "variantId": "gid://shopify/ProductVariant/52590221230364",
        "name": "Happy Hippy Shower gel",
        "productType": "Shower Gel",
        "strapline": "Zesty grapefruit wake up call",
        "scent": "Citrus",
        "benefit": "Cleansing",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/happy_hippy_shower_gel.jpg?v=1761297753",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC00270.jpg?v=1753298813",
        "imageAlt": "A clear yellow circular swatch of a lush shower gel that smells like lemon.",
        "productUrl": "https://lush.co.za/products/sample-happy-hippy-shower-gel",
        "inStock": true,
        "category": "Shower"
      },
      {
        "id": "gid://shopify/Product/10192994566428",
        "handle": "sample-magic-crystals-shower-scrub",
        "variantId": "gid://shopify/ProductVariant/52590224081180",
        "name": "Magic Crystals Shower Scrub",
        "productType": "Body Scrub",
        "strapline": "Herbaceous, exfoliating potion",
        "scent": "Fresh",
        "benefit": "Muscle soothing",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/magic_crystals_01.png?v=1725536551",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC00276.jpg?v=1753299165",
        "imageAlt": "A purple textured swatch of a lush salt scrub that smells like mint. ",
        "productUrl": "https://lush.co.za/products/sample-magic-crystals-shower-scrub",
        "inStock": true,
        "category": "Shower"
      },
      {
        "id": "gid://shopify/Product/10192995713308",
        "handle": "sample-olive-shower-gel",
        "variantId": "gid://shopify/ProductVariant/53337921388828",
        "name": "The Olive Branch Shower gel",
        "productType": "Shower Gel",
        "strapline": "Assuring mandarin & olive oil",
        "scent": "Citrus",
        "benefit": "Hydrating",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/olive_branch_shower_gel.jpg?v=1761298295",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC00272.jpg?v=1753299450",
        "imageAlt": "An orange circular swatch of a lush shower gel that smells like olives. ",
        "productUrl": "https://lush.co.za/products/sample-olive-shower-gel",
        "inStock": true,
        "category": "Shower"
      },
      {
        "id": "gid://shopify/Product/10192995746076",
        "handle": "sample-dirty-springwash-shower-gel",
        "variantId": "gid://shopify/ProductVariant/52590232011036",
        "name": "Dirty Springwash Shower gel",
        "productType": "Shower Gel",
        "strapline": "Wake up with minty tingles",
        "scent": "Fresh",
        "benefit": "Muscle soothing",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/dirty_springwash_shower_gel.jpg?v=1761297648",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC00267.jpg?v=1753299043",
        "imageAlt": "A clear blue circular swatch of a lush shower gel that smells like citrus. ",
        "productUrl": "https://lush.co.za/products/sample-dirty-springwash-shower-gel",
        "inStock": true,
        "category": "Shower"
      },
      {
        "id": "gid://shopify/Product/10619393474844",
        "handle": "sample-good-karma-shower-gel",
        "variantId": "gid://shopify/ProductVariant/53032221049116",
        "name": "Good Karma Shower Gel",
        "productType": "Shower Gel",
        "strapline": "Earthy patchouli & ripe orange",
        "scent": "Citrus",
        "benefit": "Cleansing",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/good_karma_shower_gel_jpeg.jpg?v=1733303440",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC01209.jpg?v=1763616959",
        "imageAlt": "SAMPLE: Good Karma Shower Gel",
        "productUrl": "https://lush.co.za/products/sample-good-karma-shower-gel",
        "inStock": true,
        "category": "Shower"
      }
    ],
    "Body": [
      {
        "id": "gid://shopify/Product/10054710984988",
        "handle": "sleepy-body-lotion-1",
        "variantId": "gid://shopify/ProductVariant/51334492586268",
        "name": "Sleepy Body Lotion",
        "productType": "Body Lotion",
        "strapline": "Recommended by your bestie",
        "scent": "Floral",
        "benefit": "Calming",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/Sleepylotion23.jpg?v=1698742118",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC09560.jpg?v=1741165778",
        "imageAlt": "A purple circular swatch of a lush body lotion that smells like lavender ",
        "productUrl": "https://lush.co.za/products/sleepy-body-lotion-1",
        "inStock": true,
        "category": "Body"
      },
      {
        "id": "gid://shopify/Product/10054711017756",
        "handle": "dream-cream-body-lotion-1",
        "variantId": "gid://shopify/ProductVariant/51334554681628",
        "name": "Dream Cream Body Lotion",
        "productType": "Body Lotion",
        "strapline": "Oat & Lavender cult classic",
        "scent": "Lightly scented",
        "benefit": "Soothing",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/Dreamcream23.jpg?v=1698742380",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC09556.jpg?v=1741166162",
        "imageAlt": "A cream tear-shaped swatch of a lush body lotion that smells herbal. ",
        "productUrl": "https://lush.co.za/products/dream-cream-body-lotion-1",
        "inStock": true,
        "category": "Body"
      },
      {
        "id": "gid://shopify/Product/10054711050524",
        "handle": "sticky-dates-body-lotion-1",
        "variantId": "gid://shopify/ProductVariant/51334574899484",
        "name": "Sticky Dates Body Lotion",
        "productType": "Body Lotion",
        "strapline": "A sweet, indulgent and luxurious fan-favourite",
        "scent": "Gourmand",
        "benefit": "Softening",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/sticky_dates_body_lotion_02.jpg?v=1710506847",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC09576.jpg?v=1741165362",
        "imageAlt": "A yellow tear-shaped swatch of a lush body lotion that smells like warm pudding. ",
        "productUrl": "https://lush.co.za/products/sticky-dates-body-lotion-1",
        "inStock": true,
        "category": "Body"
      },
      {
        "id": "gid://shopify/Product/10054711116060",
        "handle": "karma-kream",
        "variantId": "gid://shopify/ProductVariant/51334583484700",
        "name": "Karma Kream",
        "productType": "Body Lotion",
        "strapline": "Grounding orange, patchouli, and pine for soft skin",
        "scent": "Herbal",
        "benefit": "Hydrating",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/Karmacream23.jpg?v=1698742655",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC09565.jpg?v=1741165217",
        "imageAlt": "A cream circular swatch of a lush body lotion that smells like citrus. ",
        "productUrl": "https://lush.co.za/products/karma-kream",
        "inStock": true,
        "category": "Body"
      },
      {
        "id": "gid://shopify/Product/10156947079452",
        "handle": "sample-lime-bounty-body-butter",
        "variantId": "gid://shopify/ProductVariant/51850592452892",
        "name": "Lime Bounty Body Butter",
        "productType": "Body Butter",
        "strapline": "Reward skin with lime luxury",
        "scent": "Citrus",
        "benefit": "Hydrating",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/Limebounty23.jpg?v=1698742221",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC09792.jpg?v=1753108227",
        "imageAlt": "A green circular swatch of a lush body lotion that smells like key lime. ",
        "productUrl": "https://lush.co.za/products/sample-lime-bounty-body-butter",
        "inStock": true,
        "category": "Body"
      },
      {
        "id": "gid://shopify/Product/10156947144988",
        "handle": "sample-sympathy-for-the-skin-lotion",
        "variantId": "gid://shopify/ProductVariant/51850626138396",
        "name": "Sympathy for the Skin Lotion",
        "productType": "Body Lotion",
        "strapline": "Vanilla & Banana skin soother",
        "scent": "Lightly scented",
        "benefit": "Hydrating",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/Sympathy23.jpg?v=1698742074",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/8A2345F4-C9FB-4BC3-9667-47370747E4BE.png?v=1747245542",
        "imageAlt": "A white circular swatch of a lush body lotion that smells like soft vanilla beans. ",
        "productUrl": "https://lush.co.za/products/sample-sympathy-for-the-skin-lotion",
        "inStock": true,
        "category": "Body"
      },
      {
        "id": "gid://shopify/Product/10515882508572",
        "handle": "sample-biomic-body-lotion",
        "variantId": "gid://shopify/ProductVariant/52606489035036",
        "name": "Biomic Body Lotion",
        "productType": "Body Lotion",
        "strapline": "Firming and beautifying",
        "scent": "Lightly scented",
        "benefit": "Firming",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/Biomic23.jpg?v=1698742446",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC00277.jpg?v=1753300997",
        "imageAlt": "A cream circular swatch of a lush body lotion that is subtly scented. ",
        "productUrl": "https://lush.co.za/products/sample-biomic-body-lotion",
        "inStock": true,
        "category": "Body"
      },
      {
        "id": "gid://shopify/Product/10515882574108",
        "handle": "sample-pansy-body-lotion",
        "variantId": "gid://shopify/ProductVariant/52606489100572",
        "name": "Pansy Body Lotion",
        "productType": "Body Lotion",
        "strapline": "Hydrating Olive Oil & Mandarin",
        "scent": "Citrus",
        "benefit": "Soothing",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/Pansy23.jpg?v=1698742162",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC00278.jpg?v=1753300709",
        "imageAlt": "A cream tear-shaped swatch of a lush body lotion that smells like olive oil. ",
        "productUrl": "https://lush.co.za/products/sample-pansy-body-lotion",
        "inStock": false,
        "category": "Body"
      },
      {
        "id": "gid://shopify/Product/10822533153052",
        "handle": "sample-p",
        "variantId": "gid://shopify/ProductVariant/54061695861020",
        "name": "Pink Peppermint",
        "productType": "Foot Lotion",
        "strapline": "A minty treat for tired feet",
        "scent": "Fresh",
        "benefit": "Muscle soothing",
        "badge": "🌟 STAFF-CURATED",
        "badgeColor": "#000000",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/pink_peppermint_lotion_1.jpg?v=1771580338",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/pink_peppermint_lotion_1.jpg?v=1771580338",
        "imageAlt": "SAMPLE: Pink Peppermint",
        "productUrl": "https://lush.co.za/products/sample-p",
        "inStock": true,
        "category": "Body"
      },
      {
        "id": "gid://shopify/Product/10822554681628",
        "handle": "sample-super-fairy",
        "variantId": "gid://shopify/ProductVariant/54061765361948",
        "name": "Super Fairy",
        "productType": "Body Lotion",
        "strapline": "The sweetest scent mashup",
        "scent": "Gourmand",
        "benefit": "Hydrating",
        "badge": "🌟 STAFF-CURATED",
        "badgeColor": "#000000",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/super_fiary_body_lotion_01.jpg?v=1756738632",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/super_fiary_body_lotion_01.jpg?v=1756738632",
        "imageAlt": "SAMPLE: Super Fairy",
        "productUrl": "https://lush.co.za/products/sample-super-fairy",
        "inStock": false,
        "category": "Body"
      },
      {
        "id": "gid://shopify/Product/10822548488476",
        "handle": "sample-ocean-salt",
        "variantId": "gid://shopify/ProductVariant/54061747798300",
        "name": "Ocean Salt",
        "productType": "Facial Scrub",
        "strapline": "Refreshing sea salt scrub",
        "scent": "Citrus",
        "benefit": "Bightening",
        "badge": "🌟 STAFF-CURATED",
        "badgeColor": "#000000",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/ocean_salt.png?v=1725978759",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/ocean_salt.png?v=1725978759",
        "imageAlt": "SAMPLE: Ocean Salt",
        "productUrl": "https://lush.co.za/products/sample-ocean-salt",
        "inStock": true,
        "category": "Body"
      },
      {
        "id": "gid://shopify/Product/10515882443036",
        "handle": "sample-cocoa-butter-hand-body-lotion",
        "variantId": "gid://shopify/ProductVariant/52606488969500",
        "name": "Cocoa Butter Hand & Body Lotion",
        "productType": "Body Lotion",
        "strapline": "Butter up your skin!",
        "scent": "Lightly scented",
        "benefit": "Hydrating",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/cocoa_butter_1.jpg?v=1770114838",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC00271.jpg?v=1753300536",
        "imageAlt": "A white tear-shaped swatch of a lush body lotion that smells like cocoa butter. ",
        "productUrl": "https://lush.co.za/products/sample-cocoa-butter-hand-body-lotion",
        "inStock": true,
        "category": "Body"
      },
      {
        "id": "gid://shopify/Product/10894908653852",
        "handle": "sample-handy-gurgu",
        "variantId": "gid://shopify/ProductVariant/54291202769180",
        "name": "Handy Gurugu",
        "productType": "Hand Cream",
        "strapline": "Sublimely buttery & protective",
        "scent": "Lightly scented",
        "benefit": "Soothing",
        "badge": "🌟 STAFF-CURATED",
        "badgeColor": "#000000",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/handy_gurugu_hand_lotion_01.png?v=1690284100",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/handy_gurugu_hand_lotion_01.png?v=1690284100",
        "imageAlt": "A white circular swatch of a lush hand lotion that smells herbal. ",
        "productUrl": "https://lush.co.za/products/sample-handy-gurgu",
        "inStock": false,
        "category": "Body"
      },
      {
        "id": "gid://shopify/Product/10947515187484",
        "handle": "sample-flaxseed",
        "variantId": "gid://shopify/ProductVariant/54444040814876",
        "name": "Flaxseed",
        "productType": "Hand Cream",
        "strapline": "Your flaxseed fave",
        "scent": "Herbal",
        "benefit": "Hydrating",
        "badge": "🌟 STAFF-CURATED",
        "badgeColor": "#000000",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/flaxseed_hand_cream.jpg?v=1780316087",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/flaxseed_hand_cream.jpg?v=1780316087",
        "imageAlt": "A cream tear-shaped swatch of a lush hand cream that smells nutty. ",
        "productUrl": "https://lush.co.za/products/sample-flaxseed",
        "inStock": true,
        "category": "Body"
      }
    ],
    "Skin": [
      {
        "id": "gid://shopify/Product/10054712918300",
        "handle": "angels-on-bare-skin-cleanser",
        "variantId": "gid://shopify/ProductVariant/51334832095516",
        "name": "Angels on Bare Skin Cleanser",
        "productType": "Facial Cleanser",
        "strapline": "Our bestselling gentle cleanse",
        "scent": "Herbal",
        "benefit": "Soothing",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/angels_on_bare_skin_cleanser_01.jpg?v=1690285795",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC09582.jpg?v=1741165119",
        "imageAlt": "SAMPLE: Angels on Bare Skin Cleanser",
        "productUrl": "https://lush.co.za/products/angels-on-bare-skin-cleanser",
        "inStock": true,
        "category": "Skin"
      },
      {
        "id": "gid://shopify/Product/10054713147676",
        "handle": "cup-of-coffee-face-mask",
        "variantId": "gid://shopify/ProductVariant/51334923518236",
        "name": "Cup Of Coffee Face Mask",
        "productType": "Face Mask",
        "strapline": "Wake up and smell the coffee",
        "scent": "Gourmand",
        "benefit": "Bightening",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/cup_o_coffe_face_mask_01.jpg?v=1690291261",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC09547.jpg?v=1741165001",
        "imageAlt": "A brown circular swatch of a face and body mask with exfoliating coffee grounds inside. ",
        "productUrl": "https://lush.co.za/products/cup-of-coffee-face-mask",
        "inStock": true,
        "category": "Skin"
      },
      {
        "id": "gid://shopify/Product/10054713180444",
        "handle": "let-the-good-times-roll-cleanser",
        "variantId": "gid://shopify/ProductVariant/52590209302812",
        "name": "Let the Good Time's Roll Cleanser",
        "productType": "Facial Cleanser",
        "strapline": "Stimulate, polish, and soften",
        "scent": "Gourmand",
        "benefit": "Softening",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/let_the_good_times_roll_cleanser.jpg?v=1762944282",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC09551.jpg?v=1741164034",
        "imageAlt": "A yellow textured swatch of a lush cleanser with popcorn pieces in it that smells like caramel. ",
        "productUrl": "https://lush.co.za/products/let-the-good-times-roll-cleanser",
        "inStock": true,
        "category": "Skin"
      },
      {
        "id": "gid://shopify/Product/10515904397596",
        "handle": "sample-mostly-face-wash",
        "variantId": "gid://shopify/ProductVariant/52606533271836",
        "name": "Mostly Face Wash",
        "productType": "Facial Cleasner",
        "strapline": "Make the most of your skin",
        "scent": "Fresh",
        "benefit": "Bightening",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/mostly_face.jpg?v=1762951914",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC00269.jpg?v=1753301252",
        "imageAlt": "A cream tear-shaped swatch of a lush cleanser that smells like peppermint. ",
        "productUrl": "https://lush.co.za/products/sample-mostly-face-wash",
        "inStock": true,
        "category": "Skin"
      },
      {
        "id": "gid://shopify/Product/10605017956636",
        "handle": "sample-aqua-marina-cleanser",
        "variantId": "gid://shopify/ProductVariant/52977561567516",
        "name": "Aqua Marina Cleanser",
        "productType": "Facial Cleasner",
        "strapline": "Mineral-rich mattifying wash",
        "scent": "Herbal",
        "benefit": "Cleansing",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/aqua_marina_01.jpg?v=1757837287",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC01210.jpg?v=1763617151",
        "imageAlt": "A pink circular swatch of a lush cleanser with bits of seaweed inside that smells like strawberries. ",
        "productUrl": "https://lush.co.za/products/sample-aqua-marina-cleanser",
        "inStock": true,
        "category": "Skin"
      },
      {
        "id": "gid://shopify/Product/10619393343772",
        "handle": "sample-matcha-face-mask",
        "variantId": "gid://shopify/ProductVariant/53032214298908",
        "name": "Matcha Face Mask",
        "productType": "Face Mask",
        "strapline": "A nutrient-rich skincare smoothie",
        "scent": "Herbal",
        "benefit": "Bightening",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/matcha_01.jpg?v=1757837121",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/matcha_01.jpg?v=1757837121",
        "imageAlt": "A green tear-shaped textured swatch of a lush fresh face mask that smells like matcha. ",
        "productUrl": "https://lush.co.za/products/sample-matcha-face-mask",
        "inStock": true,
        "category": "Skin"
      },
      {
        "id": "gid://shopify/Product/10619393376540",
        "handle": "sample-date-night-face-mask",
        "variantId": "gid://shopify/ProductVariant/53032217674012",
        "name": "Date Night Face Mask",
        "productType": "Face Mask",
        "strapline": "Great for a date",
        "scent": "Herbal",
        "benefit": "Soothing",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/date_night_01.jpg?v=1757837483",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC01211.jpg?v=1763617280",
        "imageAlt": "A red-brown circular swatch of a lush fresh face mask that has bits of date in it. ",
        "productUrl": "https://lush.co.za/products/sample-date-night-face-mask",
        "inStock": true,
        "category": "Skin"
      },
      {
        "id": "gid://shopify/Product/10629009539356",
        "handle": "sample-mask-of-magnaminty-face-mask",
        "variantId": "gid://shopify/ProductVariant/54059655201052",
        "name": "Mask of Magnaminty Face Mask",
        "productType": "Face Mask",
        "strapline": "Natural and deep cleansing exfoliation",
        "scent": "Fresh",
        "benefit": "Bightening",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/mask_of_mag.png?v=1776242431",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC01208.jpg?v=1763616906",
        "imageAlt": "SAMPLE: Mask of Magnaminty Face Mask",
        "productUrl": "https://lush.co.za/products/sample-mask-of-magnaminty-face-mask",
        "inStock": true,
        "category": "Skin"
      },
      {
        "id": "gid://shopify/Product/10822518210844",
        "handle": "dark-angels",
        "variantId": "gid://shopify/ProductVariant/54061651558684",
        "name": "Dark Angels",
        "productType": "Facial Cleanser",
        "strapline": "Polishing charcoal cleanser",
        "scent": "Herbal",
        "benefit": "Break Out Control",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/dark_angels_cleanser_01.jpg?v=1690286572",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/dark_angels_cleanser_01.jpg?v=1690286572",
        "imageAlt": "SAMPLE: Dark Angels",
        "productUrl": "https://lush.co.za/products/dark-angels",
        "inStock": true,
        "category": "Skin"
      },
      {
        "id": "gid://shopify/Product/10822545604892",
        "handle": "sample-cosmetic-lad",
        "variantId": "gid://shopify/ProductVariant/54061710410012",
        "name": "Cosmetic Lad",
        "productType": "Facial Moisturiser",
        "strapline": "Calming, balancing, protective",
        "scent": "Lightly scented",
        "benefit": "Soothing",
        "badge": "🌟 STAFF-CURATED",
        "badgeColor": "#000000",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/cosmetic_lad_moisturiser_01.jpg?v=1690294066",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/cosmetic_lad_moisturiser_01.jpg?v=1690294066",
        "imageAlt": "A white circular textured swatch of a lush moisturiser. ",
        "productUrl": "https://lush.co.za/products/sample-cosmetic-lad",
        "inStock": false,
        "category": "Skin"
      },
      {
        "id": "gid://shopify/Product/10605017858332",
        "handle": "sample-turmeric-face-mask",
        "variantId": "gid://shopify/ProductVariant/52977561338140",
        "name": "Turmeric Face Mask",
        "productType": "Face Mask",
        "strapline": "Get glowing with turmeric, ginger and orange juice",
        "scent": "Spicy",
        "benefit": "Bightening",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/turmeric_face_mask_01.jpg?v=1757838237",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/turmeric_face_mask_01.jpg?v=1757838237",
        "imageAlt": "A yellow tear-shaped textured swatch of a lush fresh face mask that smells like carrots. ",
        "productUrl": "https://lush.co.za/products/sample-turmeric-face-mask",
        "inStock": false,
        "category": "Skin"
      }
    ],
    "Hair": [
      {
        "id": "gid://shopify/Product/10054714753308",
        "handle": "fairly-traded-honey-shampoo",
        "variantId": "gid://shopify/ProductVariant/51375209382172",
        "name": "Fairly traded Honey Shampoo",
        "productType": "Shampoo",
        "strapline": "A golden gift to hydrate hair",
        "scent": "Gourmand",
        "benefit": "Hydrating",
        "badge": "FAN FAVOURITE",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/fairly_traded_honey_shampoo_02.jpg?v=1690382081",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC09580.jpg?v=1741163480",
        "imageAlt": "A clear orange circular swatch of a lush liquid shampoo that smells like honey. ",
        "productUrl": "https://lush.co.za/products/fairly-traded-honey-shampoo",
        "inStock": true,
        "category": "Hair"
      },
      {
        "id": "gid://shopify/Product/10054714786076",
        "handle": "rehab-shampoo-1",
        "variantId": "gid://shopify/ProductVariant/51335040336156",
        "name": "Rehab Shampoo",
        "productType": "Shampoo",
        "strapline": "A restoring, minty refresh",
        "scent": "Fresh",
        "benefit": "Cleansing",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/rehab_shampoo.jpg?v=1693666855",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC09568.jpg?v=1741163281",
        "imageAlt": "A clear yellow circular swatch of a lush liquid shampoo that smells zesty. ",
        "productUrl": "https://lush.co.za/products/rehab-shampoo-1",
        "inStock": true,
        "category": "Hair"
      },
      {
        "id": "gid://shopify/Product/10054715015452",
        "handle": "jasmin-and-henna-treatment",
        "variantId": "gid://shopify/ProductVariant/51335082967324",
        "name": "Jasmin and Henna Treatment",
        "productType": "Hair Treatment",
        "strapline": "Sensual Jasmine hair saviour",
        "scent": "Herbal",
        "benefit": "Shine Enducing",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/jasmine_and_henna_fluff_ease_hair_treatment_01.jpg?v=1690438539",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC09553.jpg?v=1741168376",
        "imageAlt": "A light brown oval-shaped swatch of a lush hair treatment that smells like jasmine. ",
        "productUrl": "https://lush.co.za/products/jasmin-and-henna-treatment",
        "inStock": true,
        "category": "Hair"
      },
      {
        "id": "gid://shopify/Product/10156947276060",
        "handle": "sample-wasabi-shampoo",
        "variantId": "gid://shopify/ProductVariant/51850632069404",
        "name": "Wasabi Shampoo",
        "productType": "Shampoo",
        "strapline": "Spicy stimulation",
        "scent": "Spicy",
        "benefit": "Scalp Stimulating",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/wasabi_shan_kui_shampoo_02.jpg?v=1690382426",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/D8EC6C57-3554-4F3F-A95C-F7F86F77E8EA.png?v=1747245877",
        "imageAlt": "A green circular swatch of a lush liquid shampoo that smells like wasabi. ",
        "productUrl": "https://lush.co.za/products/sample-wasabi-shampoo",
        "inStock": true,
        "category": "Hair"
      },
      {
        "id": "gid://shopify/Product/10156947636508",
        "handle": "sample-candy-rain",
        "variantId": "gid://shopify/ProductVariant/51850711007516",
        "name": "Candy Rain Conditioner",
        "productType": "Conditioner",
        "strapline": "Soften and smooth your ‘do",
        "scent": "Gourmand",
        "benefit": "Hydrating",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/Candyrain23.jpg?v=1697807981",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC09783.jpg?v=1747247241",
        "imageAlt": "A white circular swatch of a lush cream conditioner that smells like candy.",
        "productUrl": "https://lush.co.za/products/sample-candy-rain",
        "inStock": true,
        "category": "Hair"
      },
      {
        "id": "gid://shopify/Product/10509487767836",
        "handle": "sample-happy-happy-joy-joy",
        "variantId": "gid://shopify/ProductVariant/52590237876508",
        "name": "Happy Happy Joy Joy Conditioner",
        "productType": "Conditioner",
        "strapline": "Decadantly perfumed hair treat",
        "scent": "Gourmand",
        "benefit": "Hydrating",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/happy_happy_joy_joy_conditioner_01.jpg?v=1690400389",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/happy_happy_joy_joy_conditioner_01.jpg?v=1690400389",
        "imageAlt": "A white tear-shaped swatch of a lush liquid conditioner that smells like perfume. ",
        "productUrl": "https://lush.co.za/products/sample-happy-happy-joy-joy",
        "inStock": true,
        "category": "Hair"
      },
      {
        "id": "gid://shopify/Product/10822503235868",
        "handle": "sample-swell",
        "variantId": "gid://shopify/ProductVariant/54061598277916",
        "name": "Power Conditioner",
        "productType": "Shampoo",
        "strapline": "For fuller, stronger locks",
        "scent": "Fresh",
        "benefit": "Shine Enducing",
        "badge": "🌟 STAFF-CURATED",
        "badgeColor": "#000000",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/Power23.jpg?v=1697806966",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/Power23.jpg?v=1697806966",
        "imageAlt": "A brown tear-shaped swatch of a lush cream conditioner that smells like syrup. ",
        "productUrl": "https://lush.co.za/products/sample-swell",
        "inStock": true,
        "category": "Hair"
      },
      {
        "id": "gid://shopify/Product/10822557237532",
        "handle": "sample-super-milk-shampoo",
        "variantId": "gid://shopify/ProductVariant/54061773095196",
        "name": "Super Milk Shampoo",
        "productType": "Shampoo",
        "strapline": "Try it for the fragrance, love it for the effects",
        "scent": "Gourmand",
        "benefit": "Hydrating",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/super_milk_shampoo_1.jpg?v=1767797782",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/super_milk_shampoo_1.jpg?v=1767797782",
        "imageAlt": "SAMPLE: Super Milk Shampoo",
        "productUrl": "https://lush.co.za/products/sample-super-milk-shampoo",
        "inStock": true,
        "category": "Hair"
      },
      {
        "id": "gid://shopify/Product/10822558417180",
        "handle": "sample-super-milk-conditioner",
        "variantId": "gid://shopify/ProductVariant/54061775880476",
        "name": "Super Milk Conditioner",
        "productType": "Conditioner",
        "strapline": "Give strength to your lengths!",
        "scent": "Gourmand",
        "benefit": "Hydrating",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/super_milk_conditioner_1.jpg?v=1767796448",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/super_milk_conditioner_1.jpg?v=1767796448",
        "imageAlt": "SAMPLE: Super Milk Conditioner",
        "productUrl": "https://lush.co.za/products/sample-super-milk-conditioner",
        "inStock": true,
        "category": "Hair"
      },
      {
        "id": "gid://shopify/Product/10822556090652",
        "handle": "sample-glory",
        "variantId": "gid://shopify/ProductVariant/54061770539292",
        "name": "Glory",
        "productType": "Conditioner",
        "strapline": "Super rich for curls & coils",
        "scent": "Fresh",
        "benefit": "Hydrating",
        "badge": "🌟 STAFF-CURATED",
        "badgeColor": "#000000",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/glory_conditioner_01.png?v=1690400163",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/glory_conditioner_01.png?v=1690400163",
        "imageAlt": "A green tear-shaped swatch of a lush cream conditioner that smells like lime.",
        "productUrl": "https://lush.co.za/products/sample-glory",
        "inStock": true,
        "category": "Hair"
      },
      {
        "id": "gid://shopify/Product/10054714949916",
        "handle": "american-cream-conditioner-1",
        "variantId": "gid://shopify/ProductVariant/51335079493916",
        "name": "American Cream Conditioner",
        "productType": "Conditioner",
        "strapline": "Our gloss giving best seller",
        "scent": "Gourmand",
        "benefit": "Hydrating",
        "badge": "",
        "badgeColor": "",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/Americancream23.jpg?v=1697805796",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/DSC09571.jpg?v=1741162971",
        "imageAlt": "A white circular swatch of a lush liquid conditioner that smells like strawberries. ",
        "productUrl": "https://lush.co.za/products/american-cream-conditioner-1",
        "inStock": true,
        "category": "Hair"
      },
      {
        "id": "gid://shopify/Product/10156751126812",
        "handle": "sample-retread-conditioner",
        "variantId": "gid://shopify/ProductVariant/51849549971740",
        "name": "Retread Conditioner",
        "productType": "Conditioner",
        "strapline": "",
        "scent": "Citrus",
        "benefit": "Hydrating",
        "badge": "🌟 STAFF-CURATED",
        "badgeColor": "#000000",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/Retread23.jpg?v=1697806561",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/Retread23.jpg?v=1697806561",
        "imageAlt": "A white textured circular swatch of a lush cream conditioner that smells like citrus. ",
        "productUrl": "https://lush.co.za/products/sample-retread-conditioner",
        "inStock": true,
        "category": "Hair"
      },
      {
        "id": "gid://shopify/Product/10894907998492",
        "handle": "sample-veganese",
        "variantId": "gid://shopify/ProductVariant/54291201229084",
        "name": "Veganese",
        "productType": "Conditioner",
        "strapline": "Light lemon and seaweed lustre",
        "scent": "Lightly scented",
        "benefit": "Hydrating",
        "badge": "🌟 STAFF-CURATED",
        "badgeColor": "#000000",
        "imagePrimary": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/Veganese23.jpg?v=1697808281",
        "imageHover": "https://cdn.shopify.com/s/files/1/0751/1575/7852/files/Veganese23.jpg?v=1697808281",
        "imageAlt": "A white circular swatch of a lush cream conditioner that smells like lemon.",
        "productUrl": "https://lush.co.za/products/sample-veganese",
        "inStock": true,
        "category": "Hair"
      }
    ]
  }
};
